import Vue from 'vue'
import Vuex from 'vuex'
import { fetchJobs, fetchJobDetail } from '../api/jobs'
import { fetchDefaults } from '../api/llms'
import { login, logout, fetchMe, register } from '../api/auth'
import { fetchBalance } from '../api/user'

Vue.use(Vuex)

const TOKEN_KEY = 'ecomagent_token'

export default new Vuex.Store({
  state: {
    defaults: { chat: '', image: '', video: '' },
    jobList: [],
    total: 0,
    currentJob: null,
    tasks: [],
    materials: [],
    // 登录态
    token: localStorage.getItem(TOKEN_KEY) || '',
    user: null,
    // 当前客户已开通的模块（null = 尚未拉到，此时前端不拦、由后端兜底）
    modules: null,
    // 需登录时弹窗（不跳转登录页，保证未登录也能浏览平台）
    loginVisible: false,
    loginRedirect: ''
  },
  getters: {
    isLoggedIn: s => !!s.token,
    isAdmin: s => s.user ? s.user.role === 'admin' : false,
    // 模块是否已开通：未知 key / 尚未拉到模块列表都放行（后端仍会校验）
    hasModule: s => key => {
      if (!key) return true
      if (!s.modules) return true
      return s.modules.indexOf(key) >= 0
    }
  },
  mutations: {
    setDefaults(state, d) {
      state.defaults = d || { chat: '', image: '', video: '' }
    },
    setJobList(state, { list, total }) {
      state.jobList = list || []
      state.total = total || 0
    },
    setCurrentJob(state, { job, tasks, materials }) {
      state.currentJob = job || null
      state.tasks = tasks || []
      state.materials = materials || []
    },
    setAuth(state, { token, user }) {
      state.token = token || ''
      state.user = user || null
      if (token) {
        localStorage.setItem(TOKEN_KEY, token)
      } else {
        localStorage.removeItem(TOKEN_KEY)
      }
    },
    setUser(state, user) {
      state.user = user || null
    },
    setLoginVisible(state, v) {
      state.loginVisible = !!v
    },
    setLoginRedirect(state, path) {
      state.loginRedirect = path || ''
    },
    setModules(state, m) {
      state.modules = Array.isArray(m) ? m : null
    }
  },
  actions: {
    /** 初始化：有 token 则拉取当前用户 */
    async initAuth({ state, commit }) {
      if (!state.token) return
      try {
        const me = await fetchMe()
        commit('setUser', me)
      } catch (e) {
        // token 失效则清除
        commit('setAuth', { token: '', user: null })
      }
    },
    async doLogin({ commit, dispatch }, cred) {
      const d = await login(cred)
      dispatch('loadModules')
      commit('setAuth', { token: d.token, user: d })
      return d
    },
    /**
     * 註冊（邀請制）—— 信箱 + 密碼 + 邀請碼。
     *
     * 跟 doLogin 共用後半段：後端註冊成功會直接回 token，所以註冊完就是登入狀態，
     * 不用再讓用戶登一次（體驗上就是「註冊完直接進去」）。
     */
    async doRegister({ commit, dispatch }, cred) {
      const d = await register(cred)
      dispatch('loadModules')
      commit('setAuth', { token: d.token, user: d })
      return d
    },
    async doLogout({ commit }) {
      try { await logout() } catch (e) { /* ignore */ }
      commit('setAuth', { token: '', user: null })
    },
    /** 拉取当前客户已开通的模块（前端用于路由提示；后端另有硬校验） */
    /** 需要登录时调用：弹出登录框；redirect 为登录后要回到的地址 */
    openLogin({ commit }, redirect) {
      commit('setLoginRedirect', redirect || '')
      commit('setLoginVisible', true)
    },
    closeLogin({ commit }) {
      commit('setLoginVisible', false)
      commit('setLoginRedirect', '')
    },
    async loadModules({ commit }) {
      try {
        const d = await fetchBalance()
        commit('setModules', d ? d.modules : null)
      } catch (e) {
        commit('setModules', null)
      }
    },
    async loadDefaults({ commit }) {
      try {
        const d = await fetchDefaults()
        commit('setDefaults', d)
      } catch (e) {
        commit('setDefaults', { chat: '', image: '', video: '' }) // 拉不到就留空，由后端 /llms/defaults 决定
      }
    },
    async loadJobs({ commit }, params) {
      const data = await fetchJobs(params)
      commit('setJobList', { list: data.list, total: data.totalRow })
      return data
    },
    async loadJobDetail({ commit }, id) {
      const data = await fetchJobDetail(id)
      commit('setCurrentJob', data)
      return data
    }
  }
})
